import { render, staticRenderFns } from "./StatisticsTradesFilters.vue?vue&type=template&id=28879344&scoped=true&"
import script from "./StatisticsTradesFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradesFilters.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTradesFilters.vue?vue&type=style&index=0&id=28879344&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28879344",
  null
  
)

export default component.exports